import { useAuthContext } from "../contexts/AuthContext";
import { canAccessFeature, canCreateCourse, canAddStudent, getPlanByTier } from "../config/subscriptionPlans";
import { SubscriptionTier } from "../types/payment";

export const useSubscription = () => {
  const { user } = useAuthContext();
  const tier = (user?.subscriptionTier || "free") as SubscriptionTier;
  const plan = getPlanByTier(tier);

  const hasFeature = (feature: string): boolean => {
    if (!plan) return false;
    return canAccessFeature(tier, feature as any);
  };

  const canCreate = (currentCount: number): boolean => {
    return canCreateCourse(tier, currentCount);
  };

  const canAddStudents = (currentCount: number): boolean => {
    return canAddStudent(tier, currentCount);
  };

  const getMaxCourses = (): number | "unlimited" => {
    return plan?.features.maxCourses || 1;
  };

  const getMaxStudents = (): number | "unlimited" => {
    return plan?.features.maxStudents || 20;
  };

  return {
    tier,
    plan,
    hasFeature,
    canCreate,
    canAddStudents,
    getMaxCourses,
    getMaxStudents,
    hasAnalytics: hasFeature("analytics"),
    hasCertificates: hasFeature("certificates"),
    hasSubdomain: hasFeature("subdomain"),
    hasCustomDomain: hasFeature("customDomain"),
    hasWhiteLabel: hasFeature("whiteLabel"),
    hasApiAccess: hasFeature("apiAccess"),
    hasPrioritySupport: hasFeature("prioritySupport"),
    hasMultiAdmin: hasFeature("multiAdmin"),
    hasSLA: hasFeature("sla"),
    hasOnboarding: hasFeature("onboarding"),
  };
};
